import React, { useEffect, useState } from 'react';
import API from '../utils/api';
import { toast } from 'react-toastify';

export default function ManageContent() {
  const [tab, setTab] = useState('faqs');
  const [faqs, setFaqs] = useState([]);
  const [slokas, setSlokas] = useState([]);
  const [activities, setActivities] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [faqForm, setFaqForm] = useState({ question: '', answer: '', order: 0 });
  const [slokaForm, setSlokaForm] = useState({ title: '', sanskrit: '', transliteration: '', meaning: '', source: '' });
  const [activityForm, setActivityForm] = useState({ title: '', titleHindi: '', description: '', descriptionHindi: '' });

  useEffect(() => {
    API.get('/faqs').then(r => setFaqs(r.data)).catch(() => {});
    API.get('/slokas').then(r => setSlokas(r.data)).catch(() => {});
    API.get('/activities').then(r => setActivities(r.data)).catch(() => {});
  }, []);

  const handleAddFAQ = async () => {
    if (!faqForm.question || !faqForm.answer) return toast.error('Question and answer required');
    await API.post('/faqs', faqForm);
    toast.success('FAQ added');
    API.get('/faqs').then(r => setFaqs(r.data));
    setFaqForm({ question: '', answer: '', order: 0 });
    setShowForm(false);
  };

  const handleDeleteFAQ = async (id) => {
    await API.delete(`/faqs/${id}`);
    setFaqs(prev => prev.filter(f => f._id !== id));
    toast.success('FAQ removed');
  };

  const handleAddSloka = async () => {
    if (!slokaForm.title || !slokaForm.sanskrit) return toast.error('Title and Sanskrit text required');
    await API.post('/slokas', slokaForm);
    toast.success('Sloka added');
    API.get('/slokas').then(r => setSlokas(r.data));
    setSlokaForm({ title: '', sanskrit: '', transliteration: '', meaning: '', source: '' });
    setShowForm(false);
  };

  const handleDeleteSloka = async (id) => {
    await API.delete(`/slokas/${id}`);
    setSlokas(prev => prev.filter(s => s._id !== id));
    toast.success('Sloka removed');
  };

  const handleAddActivity = async () => {
    if (!activityForm.title) return toast.error('Title required');
    await API.post('/activities', activityForm);
    toast.success('Activity added');
    API.get('/activities').then(r => setActivities(r.data));
    setActivityForm({ title: '', titleHindi: '', description: '', descriptionHindi: '' });
    setShowForm(false);
  };

  const handleDeleteActivity = async (id) => {
    await API.delete(`/activities/${id}`);
    setActivities(prev => prev.filter(a => a._id !== id));
    toast.success('Activity removed');
  };

  return (
    <div>
      <h2 className="admin-page-title">📝 Manage Content</h2>

      <div style={{ display: 'flex', gap: 10, marginBottom: 24 }}>
        {[{ key: 'faqs', label: '❓ FAQs' }, { key: 'slokas', label: '🕉️ Slokas' }, { key: 'activities', label: '🌾 Activities' }].map(t => (
          <button key={t.key} className={`btn btn-sm${tab === t.key ? ' btn-primary' : ' btn-outline'}`} onClick={() => { setTab(t.key); setShowForm(false); }}>{t.label}</button>
        ))}
        <button className="btn btn-sm btn-green" style={{ marginLeft: 'auto' }} onClick={() => setShowForm(!showForm)}>+ Add</button>
      </div>

      {/* FAQ Tab */}
      {tab === 'faqs' && (
        <div>
          {showForm && (
            <div className="admin-form-card" style={{ marginBottom: 20 }}>
              <h3 style={{ fontWeight: 700, marginBottom: 16 }}>Add FAQ</h3>
              <div className="form-group"><label className="form-label">Question *</label><input className="form-input" value={faqForm.question} onChange={e => setFaqForm(p => ({ ...p, question: e.target.value }))} /></div>
              <div className="form-group"><label className="form-label">Answer *</label><textarea className="form-input" rows={4} value={faqForm.answer} onChange={e => setFaqForm(p => ({ ...p, answer: e.target.value }))} /></div>
              <div className="form-group"><label className="form-label">Order</label><input className="form-input" type="number" value={faqForm.order} onChange={e => setFaqForm(p => ({ ...p, order: e.target.value }))} /></div>
              <div style={{ display: 'flex', gap: 10 }}><button className="btn btn-primary" onClick={handleAddFAQ}>Save FAQ</button><button className="btn btn-outline" onClick={() => setShowForm(false)}>Cancel</button></div>
            </div>
          )}
          <div className="admin-table">
            <table>
              <thead><tr><th>#</th><th>Question</th><th>Answer (preview)</th><th>Action</th></tr></thead>
              <tbody>
                {faqs.map((f, i) => (
                  <tr key={f._id}>
                    <td>{i + 1}</td>
                    <td style={{ fontWeight: 600, maxWidth: 260 }}>{f.question}</td>
                    <td style={{ maxWidth: 300, fontSize: '0.85rem', color: '#666' }}>{f.answer.slice(0, 80)}...</td>
                    <td><button onClick={() => handleDeleteFAQ(f._id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: '1.1rem' }}>🗑️</button></td>
                  </tr>
                ))}
                {faqs.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center', padding: 20, color: '#888' }}>No FAQs</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Slokas Tab */}
      {tab === 'slokas' && (
        <div>
          {showForm && (
            <div className="admin-form-card" style={{ marginBottom: 20 }}>
              <h3 style={{ fontWeight: 700, marginBottom: 16 }}>Add Sloka</h3>
              <div className="form-row">
                <div className="form-group"><label className="form-label">Title *</label><input className="form-input" value={slokaForm.title} onChange={e => setSlokaForm(p => ({ ...p, title: e.target.value }))} /></div>
                <div className="form-group"><label className="form-label">Source</label><input className="form-input" value={slokaForm.source} onChange={e => setSlokaForm(p => ({ ...p, source: e.target.value }))} placeholder="Rig Veda, Mahabharata..." /></div>
              </div>
              <div className="form-group"><label className="form-label">Sanskrit Text * (Devanagari)</label><textarea className="form-input" rows={3} value={slokaForm.sanskrit} onChange={e => setSlokaForm(p => ({ ...p, sanskrit: e.target.value }))} style={{ fontFamily: 'Noto Serif Devanagari, serif', fontSize: '1.1rem' }} /></div>
              <div className="form-group"><label className="form-label">Transliteration (Roman script)</label><textarea className="form-input" rows={2} value={slokaForm.transliteration} onChange={e => setSlokaForm(p => ({ ...p, transliteration: e.target.value }))} /></div>
              <div className="form-group"><label className="form-label">Meaning (English)</label><textarea className="form-input" rows={3} value={slokaForm.meaning} onChange={e => setSlokaForm(p => ({ ...p, meaning: e.target.value }))} /></div>
              <div style={{ display: 'flex', gap: 10 }}><button className="btn btn-primary" onClick={handleAddSloka}>Save Sloka</button><button className="btn btn-outline" onClick={() => setShowForm(false)}>Cancel</button></div>
            </div>
          )}
          <div className="admin-table">
            <table>
              <thead><tr><th>#</th><th>Title</th><th>Source</th><th>Sanskrit (preview)</th><th>Action</th></tr></thead>
              <tbody>
                {slokas.map((s, i) => (
                  <tr key={s._id}>
                    <td>{i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{s.title}</td>
                    <td>{s.source || '—'}</td>
                    <td style={{ fontFamily: 'Noto Serif Devanagari, serif', maxWidth: 200, fontSize: '0.85rem' }}>{s.sanskrit.slice(0, 60)}...</td>
                    <td><button onClick={() => handleDeleteSloka(s._id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: '1.1rem' }}>🗑️</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Activities Tab */}
      {tab === 'activities' && (
        <div>
          {showForm && (
            <div className="admin-form-card" style={{ marginBottom: 20 }}>
              <h3 style={{ fontWeight: 700, marginBottom: 16 }}>Add Activity</h3>
              <div className="form-row">
                <div className="form-group"><label className="form-label">Title *</label><input className="form-input" value={activityForm.title} onChange={e => setActivityForm(p => ({ ...p, title: e.target.value }))} /></div>
                <div className="form-group"><label className="form-label">Hindi Title</label><input className="form-input" value={activityForm.titleHindi} onChange={e => setActivityForm(p => ({ ...p, titleHindi: e.target.value }))} style={{ fontFamily: 'Noto Serif Devanagari, serif' }} /></div>
              </div>
              <div className="form-group"><label className="form-label">Description</label><textarea className="form-input" rows={3} value={activityForm.description} onChange={e => setActivityForm(p => ({ ...p, description: e.target.value }))} /></div>
              <div style={{ display: 'flex', gap: 10 }}><button className="btn btn-primary" onClick={handleAddActivity}>Save</button><button className="btn btn-outline" onClick={() => setShowForm(false)}>Cancel</button></div>
            </div>
          )}
          <div className="admin-table">
            <table>
              <thead><tr><th>Title</th><th>Hindi Title</th><th>Description (preview)</th><th>Action</th></tr></thead>
              <tbody>
                {activities.map(a => (
                  <tr key={a._id}>
                    <td style={{ fontWeight: 600 }}>{a.title}</td>
                    <td style={{ fontFamily: 'Noto Serif Devanagari, serif' }}>{a.titleHindi || '—'}</td>
                    <td style={{ maxWidth: 300, fontSize: '0.85rem', color: '#666' }}>{(a.description || '').slice(0, 80)}...</td>
                    <td><button onClick={() => handleDeleteActivity(a._id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: '1.1rem' }}>🗑️</button></td>
                  </tr>
                ))}
                {activities.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center', padding: 20, color: '#888' }}>No activities</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
